import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { TripList } from '../../../../redux/trip/trip.types';
import './MapAddToListPanel.scss';

type MapAddToListPanelProps = {
  lists: TripList[];
  checkedListIds: Set<string>;
  onToggle: (listId: string) => Promise<void>;
  onClose: () => void;
};

function MapAddToListPanel({ lists, checkedListIds, onToggle, onClose }: MapAddToListPanelProps) {
  const [loadingListId, setLoadingListId] = useState<string | null>(null);

  const handleToggle = async (listId: string) => {
    if (loadingListId) {
      return;
    }
    setLoadingListId(listId);
    try {
      await onToggle(listId);
    } finally {
      setLoadingListId(null);
    }
  };

  return (
    <div className='map-add-to-list-panel'>
      <button
        className='map-add-to-list-panel__close'
        onClick={onClose}
        type='button'
        aria-label='Close'
      >
        <CloseIcon fontSize='small' />
      </button>

      <span className='map-add-to-list-panel__title'>Add to:</span>

      <ul className='map-add-to-list-panel__list'>
        {lists.map((list) => {
          const isLoading = loadingListId === list.id;
          const isDisabled = loadingListId !== null;

          return (
            <li
              key={list.id}
              className={`map-add-to-list-panel__item${isDisabled ? ' map-add-to-list-panel__item--disabled' : ''}`}
              onClick={() => handleToggle(list.id)}
            >
              <span className='map-add-to-list-panel__indicator'>
                {isLoading ? (
                  <CircularProgress
                    size={18}
                    className='map-add-to-list-panel__spinner'
                  />
                ) : (
                  <Checkbox
                    checked={checkedListIds.has(list.id)}
                    onChange={() => handleToggle(list.id)}
                    onClick={(e) => e.stopPropagation()}
                    size='small'
                    sx={{
                      padding: '2px 6px 2px 2px',
                      color: '#aaa',
                      '&.Mui-checked': { color: '#1a73e8' },
                    }}
                  />
                )}
              </span>
              <span className='map-add-to-list-panel__emoji'>{list.emoji}</span>
              <span className='map-add-to-list-panel__name'>{list.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

MapAddToListPanel.displayName = 'MapAddToListPanel';
export default MapAddToListPanel;
